import React from "react";
import UsageGuideCard from "../usage-guide-card/UsageGuideCard";
import UsageGuideStepProps from "./usage-guide-step-props.interface";
import { ReactComponent as RedArrowRightIcon } from "../../../../../assets/icons/red-arrow-right-icon.svg";
import { ReactComponent as BigHoop } from "../../../../../assets/images/big-hoop.svg";

const Intro = ({ handleNextStep, handleClose }: UsageGuideStepProps) => {
  return (
    <div className="step__intro">
      <UsageGuideCard handleClose={handleClose} isMainCardType>
        <div className="row">
          <div className="text-content col-md-6">
            <h1>Hello!</h1>
            <p>I&apos;m S23VI-ALPHA.</p>
            <p>In this snack, you&apos;ll be able to explore the sun path of a construction easily!</p>
            <p>
              This is a 3D viewer connected to Unity that shows you how the sun goes over a building.
            </p>
            <button type="button" onClick={handleNextStep} className="clickable">
              Let&apos;s start!
              <RedArrowRightIcon className="right-arrow" />
            </button>
          </div>
          <div className="col-md-6">
                <BigHoop className="side-image"/>
          </div>
        </div>
      </UsageGuideCard>
    </div>
  );
};

export default Intro;
